module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-generation-container"
  }, [_c('div', {
    staticClass: "quote-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection == 'locations'),
      expression: "activeSection == 'locations'"
    }],
    staticClass: "quote-address-section"
  }, [_c('h2', [_vm._v("Locations")]), _vm._v(" "), _c('p', [_vm._v("Select the locations you want to include on the quote")]), _vm._v(" "), _c('div', {
    staticClass: "location-container"
  }, _vm._l((_vm.leadLocations), function(location) {
    return _c('div', {
      staticClass: "location",
      class: {
        active: _vm.isSelectedLocation(location)
      },
      on: {
        "click": function($event) {
          _vm.toggleLocation(location)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(location.location.formatted_address) + "\n                ")])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.configureProducts
    }
  }, [_vm._v("NEXT: Choose Products "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])]), _vm._v(" "), (_vm.quote.locations.length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection == 'products'),
      expression: "activeSection == 'products'"
    }],
    staticClass: "quote-product-section"
  }, [_c('p', [_vm._v("Configure Products for:")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.quote.locations[_vm.locationIndex].location.formatted_address))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "product-container"
  }, [_c('div', {
    staticClass: "product-section access-container"
  }, [_c('div', {
    staticClass: "product-choice-header"
  }, [_vm._v("\n                            Access\n                        ")]), _vm._v(" "), _vm._l((_vm.attributeTree.access), function(access, accessIndex) {
    return _c('div', {
      staticClass: "product-choice",
      class: {
        active: _vm.activeProduct.access == access.name, 'disabled': typeof _vm.activeProduct.access != 'undefined' && _vm.activeProduct.access != access.name
      },
      on: {
        "click": function($event) {
          _vm.setProductChoice('access', accessIndex, access.name)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(access.name || '-') + "\n                        ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('dropdown-confirmation', {
    attrs: {
      "direction": "left",
      "triggerBtnClass": "btn-light",
      "triggerBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Access",
      "confirmBtnClass": "btn-primary",
      "confirmBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Item",
      "keepalive": ""
    },
    on: {
      "confirm": function($event) {
        _vm.addItem('access')
      },
      "close": _vm.clearNewItem
    }
  }, [_vm._t("default", [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newItem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })])], 2)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [(_vm.activeProduct.accessIndex > -1 && _vm.attributeTree.access[_vm.activeProduct.accessIndex]) ? _c('div', {
    staticClass: "product-section criteria-container"
  }, [_c('div', {
    staticClass: "product-choice-header"
  }, [_vm._v("\n                            Criteria\n\n                        ")]), _vm._v(" "), _vm._l((_vm.attributeTree.access[_vm.activeProduct.accessIndex].criteria), function(criteria, criteriaIndex) {
    return _c('div', {
      staticClass: "product-choice",
      class: {
        active: _vm.activeProduct.criteria == criteria.name, 'disabled': _vm.activeProduct.criteria && _vm.activeProduct.criteria != criteria.name
      },
      on: {
        "click": function($event) {
          _vm.setProductChoice('criteria', criteriaIndex, criteria.name)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(criteria.name || '-') + "\n                        ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('dropdown-confirmation', {
    attrs: {
      "direction": "left",
      "triggerBtnClass": "btn-light",
      "triggerBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Criteria",
      "confirmBtnClass": "btn-primary",
      "confirmBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Criteria",
      "keepalive": ""
    },
    on: {
      "confirm": function($event) {
        _vm.addItem('criteria')
      },
      "close": _vm.clearNewItem
    }
  }, [_vm._t("default", [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newItem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })])], 2)], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [(_vm.activeProduct.criteriaIndex > -1 && _vm.attributeTree.access[_vm.activeProduct.accessIndex] && _vm.attributeTree.access[_vm.activeProduct.accessIndex].criteria[_vm.activeProduct.criteriaIndex]) ? _c('div', {
    staticClass: "product-section product-list-container"
  }, [_c('div', {
    staticClass: "product-choice-header"
  }, [_vm._v("\n                            Product\n                        ")]), _vm._v(" "), _vm._l((_vm.attributeTree.access[_vm.activeProduct.accessIndex].criteria[_vm.activeProduct.criteriaIndex].products), function(product, productIndex) {
    return _c('div', {
      staticClass: "product-choice",
      class: {
        active: _vm.activeProduct.product == product.name, 'disabled': _vm.activeProduct.product && _vm.activeProduct.product != product.name
      },
      on: {
        "click": function($event) {
          _vm.setProductChoice('product', productIndex, product)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(product.name) + "\n                        ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('dropdown-confirmation', {
    attrs: {
      "direction": "left",
      "triggerBtnClass": "btn-light",
      "triggerBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Product",
      "confirmBtnClass": "btn-primary",
      "confirmBtnHtml": "<i class=\"fa fa-plus\"></i>&nbsp;&nbsp;Add Product",
      "keepalive": ""
    },
    on: {
      "confirm": function($event) {
        _vm.addItem('product')
      },
      "close": _vm.clearNewItem
    }
  }, [_vm._t("default", [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newItem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })])], 2)], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeProduct.product),
      expression: "activeProduct.product"
    }],
    staticClass: "product-section configure-container"
  }, [_c('div', {
    staticClass: "product-choice-header"
  }, [_vm._v("\n                            Details\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "product-choice-form container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5"
  }, [_vm._v("Qty")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeProduct.qty),
      expression: "activeProduct.qty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.activeProduct.qty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeProduct.qty = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5"
  }, [_vm._v("Term")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeProduct.term),
      expression: "activeProduct.term"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.activeProduct.term)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeProduct.term = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5"
  }, [_vm._v("MRC")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeProduct.mrc),
      expression: "activeProduct.mrc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.activeProduct.mrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeProduct.mrc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5"
  }, [_vm._v("NRC")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeProduct.nrc),
      expression: "activeProduct.nrc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.activeProduct.nrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeProduct.nrc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setProduct
    }
  }, [_vm._v("Add to Quote   "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])])])])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-light",
    on: {
      "click": _vm.configureLocations
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v("  PREV: Choose Locations")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationIndex < _vm.quote.locations.length - 1),
      expression: "locationIndex < quote.locations.length - 1"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.nextLocation
    }
  }, [_vm._v("  Next Location "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "quote-section quote-summary"
  }, [_c('div', {
    staticClass: "quote-summary-header"
  }, [_c('h4', [_vm._v("Quote For")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.carrier.carrier_name))])]), _vm._v(" "), _c('div', {
    staticClass: "quote-summary-body"
  }, [_c('h4', [_vm._v("\n                  \n                Addresses (" + _vm._s(_vm.quote.locations.length) + ")")]), _vm._v(" "), _vm._l((_vm.quote.locations), function(l) {
    return _c('div', [_c('div', {
      staticClass: "summary-location",
      on: {
        "click": function($event) {
          _vm.expanded.locations.indexOf(l) >= 0 ? _vm.expanded.locations.splice(_vm.expanded.locations.indexOf(l), 1) : _vm.expanded.locations.push(l)
        }
      }
    }, [_c('div', {
      staticClass: "location-expander"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded.locations.indexOf(l) >= 0),
        expression: "expanded.locations.indexOf(l) >= 0"
      }],
      staticClass: "fa fa-minus"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded.locations.indexOf(l) < 0),
        expression: "expanded.locations.indexOf(l) < 0"
      }],
      staticClass: "fa fa-plus"
    })]), _vm._v(" "), _c('div', {
      staticClass: "location-detail"
    }, [_vm._v("\n                        " + _vm._s(l.location.formatted_address) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "location-action"
    }, [_c('button', {
      staticClass: "btn btn-clear",
      on: {
        "click": function($event) {
          _vm.quote.locations.splice(_vm.quote.locations.indexOf(l), 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]), _vm._v(" "), _vm._l((l.Products), function(product) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.expanded.locations.indexOf(l) >= 0),
          expression: "expanded.locations.indexOf(l) >= 0"
        }],
        staticClass: "summary-location-product"
      }, [_c('div', {
        staticClass: "product-detail"
      }, [_c('strong', [_vm._v(_vm._s(product.product))]), _c('br'), _vm._v("\n                        " + _vm._s(product.access) + " / " + _vm._s(product.criteria)), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
        staticClass: "location-action"
      }, [_c('button', {
        staticClass: "btn btn-clear",
        on: {
          "click": function($event) {
            l.Products.splice(l.Products.indexOf(product), 1)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "location-product-detail"
      }, [_c('div', {
        staticClass: "quoted-product-details"
      }, [_c('label', [_vm._v("QTY:")]), _c('span', [_vm._v(_vm._s(product.qty))])]), _vm._v(" "), _c('div', {
        staticClass: "quoted-product-details"
      }, [_c('label', [_vm._v("Term:")]), _c('span', [_vm._v(_vm._s(product.term))])]), _vm._v(" "), _c('div', {
        staticClass: "quoted-product-details"
      }, [_c('label', [_vm._v("MRC:")]), _c('span', [_vm._v(_vm._s(product.mrc) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "quoted-product-details"
      }, [_c('label', [_vm._v("NRC:")]), _c('span', [_vm._v(_vm._s(product.nrc) + "%")])])])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "quote-summary-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationIndex >= _vm.quote.locations.length - 1),
      expression: "locationIndex >= quote.locations.length - 1"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Save Quote ")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c800010!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/Quote.vue
// module id = 365
// module chunks = 0